/**
 * Created by wjjn3481 on 2017/7/11.
 */

import AddPositionDialog from '../operation/addPositionDialog.vue'
import PreviewPosition from './previewPosition.vue'
import operationMixin from '../operation/operationMixin.js'
import selectMapMixin from 'mixins/selectMapMixin'

export default {
    'mixins': [selectMapMixin, operationMixin],
    components: {
        AddPositionDialog, PreviewPosition
    }
}


// WEBPACK FOOTER //
// ./src/views/position/positionMixin.js